import { useEffect, useState } from 'react'
import { useGetContractPeriodQuery } from '../../../store/auth/authService'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { ImageDownloadButton } from '../ImageDownloadButton'
import moment from 'moment'
import FilterDatePeriodYear from '../../tableHelpers/filters/FilterDatePeriodYear'

const FilterComparison = (props: {
    value: {
        periodFrom1: string,
        periodTo1: string
        periodFrom2: string,
        periodTo2: string
    },
    isLoadingFetch: boolean,
    fetchPage: any,
    savePictures: any,
    saveExcel?: any,
    disabledSave: any,
}) => {
    const {
        value,
        isLoadingFetch,
        fetchPage,
        savePictures,
        disabledSave,
        saveExcel
        // defaulPeriodFrom,
        // defaulPeriodTo
    } = props

    const { t } = useTranslation()
    const { param_contract_id } = useParams()
    const { data } = useGetContractPeriodQuery({
        contract_id: param_contract_id,
        endOffset: 3
    })
    const {
        control,
        getValues,
        setValue,
    } = useForm<{
        periodFrom1: string,
        periodTo1: string
        periodFrom2: string,
        periodTo2: string
    }>({
        defaultValues: {},
    })

    useEffect(() => {
        setValue('periodFrom1', value.periodFrom1)
        setValue('periodFrom2', value.periodFrom2)
        setValue('periodTo1', value.periodTo1)
        setValue('periodTo2', value.periodTo2)
    }, [value]);


    const [filtersState, setFiltersState] = useState<{
        periodFrom1: string,
        periodTo1: string
        periodFrom2: string,
        periodTo2: string
    }>({
        periodFrom1: value.periodFrom1,
        periodTo1: value.periodTo1,
        periodFrom2: value.periodFrom2,
        periodTo2: value.periodTo2
    });

    const handleCloseFilter = () => {
        const values = getValues()
        setFiltersState({
            periodFrom1: values.periodFrom1,
            periodTo1: values.periodTo1,
            periodFrom2: values.periodFrom2,
            periodTo2: values.periodTo2
        })
        if (JSON.stringify(values) !== JSON.stringify(filtersState)) {
            // fetch page with new filters 
            fetchPage(values)
        }
    }

    return (

        <div className='flex flex-wrap tab:flex-nowrap justify-center tab:items-center gap-[16px] tab:gap-[75px] my-[24px] tab:my-[32px]'>
            <div className='min-w-[40%] tab:w-auto tab:min-w-[auto] order-[1]'>
                <FilterDatePeriodYear
                    hideLabel
                    isLoadingFetch={isLoadingFetch || !value.periodFrom1}
                    placement={'bottom-start'}
                    control={control}
                    fieldName1={'periodFrom1'}
                    fieldName2={'periodTo1'}
                    label1={t("filters.period_from")}
                    label2={t("filters.period_to")}
                    datesData={data}
                    handleCloseFilter={handleCloseFilter}
                    isDisabled1={(date: string) => {
                        return false
                    }}
                    isDisabled2={(date: string) => {
                        return moment(filtersState.periodFrom1, 'MM-YYYY').isAfter(moment(date, 'MM-YYYY'))
                    }}
                    dateFormatter1={(date: string, dateTo: string) => {
                        if (moment(date, 'MM-YYYY').isAfter(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(11, 'month').isBefore(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').isAfter(moment(dateTo, 'MM-YYYY'))) {
                            return moment(date, 'MM-YYYY').add(11, 'month').format('MM-YYYY')
                        }
                        else {
                            return dateTo
                        }
                    }}
                    dateFormatter2={(date: string, dateFrom: string) => {
                        if (moment(date, 'MM-YYYY').isBefore(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(-11, 'month').isAfter(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').isBefore(moment(dateFrom, 'MM-YYYY'))) {
                            return moment(date, 'MM-YYYY').add(-11, 'month').format('MM-YYYY')
                        }
                        else {
                            return dateFrom
                        }
                    }}
                />

            </div>
            <ImageDownloadButton
                className='order-[4] tab:order-[2]'
                handleDownloadPng={savePictures}
                handleDownloadExcel={saveExcel}
                text={t('download')}
                disabled={disabledSave}
            />
            <div className='min-w-[40%] tab:w-auto tab:min-w-[auto] order-[3]'>
                <FilterDatePeriodYear
                    hideLabel
                    isLoadingFetch={isLoadingFetch || !value.periodFrom2}
                    placement={'bottom-start'}
                    control={control}
                    fieldName1={'periodFrom2'}
                    fieldName2={'periodTo2'}
                    label1={t("filters.period_from")}
                    label2={t("filters.period_to")}
                    datesData={data}
                    handleCloseFilter={handleCloseFilter}
                    isDisabled1={(date: string) => {
                        return false
                    }}
                    isDisabled2={(date: string) => {
                        return moment(filtersState.periodFrom2, 'MM-YYYY').isAfter(moment(date, 'MM-YYYY'))
                    }}
                    dateFormatter1={(date: string, dateTo: string) => {
                        if (moment(date, 'MM-YYYY').isAfter(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(11, 'month').isBefore(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').isAfter(moment(dateTo, 'MM-YYYY'))) {
                            return moment(date, 'MM-YYYY').add(11, 'month').format('MM-YYYY')
                        }
                        else {
                            return dateTo
                        }
                    }}
                    dateFormatter2={(date: string, dateFrom: string) => {
                        if (moment(date, 'MM-YYYY').isBefore(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(-11, 'month').isAfter(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').isBefore(moment(dateFrom, 'MM-YYYY'))) {
                            return moment(date, 'MM-YYYY').add(-11, 'month').format('MM-YYYY')
                        }
                        else {
                            return dateFrom
                        }
                    }}
                />

            </div>
        </div>
    )
}

export default FilterComparison